(function () {
const $e560fa9b55d4e311$export$9f048bf86ee2e9d2 = [
    {
        number: 1,
        pos: [
            47,
            71
        ]
    },
    {
        number: 2,
        pos: [
            56,
            56
        ]
    },
    {
        number: 3,
        pos: [
            64,
            43
        ]
    },
    {
        number: 4,
        pos: [
            63,
            26
        ]
    },
    {
        number: 5,
        pos: [
            61,
            16
        ]
    },
    {
        number: 6,
        pos: [
            53,
            7.5
        ]
    },
    {
        number: 7,
        pos: [
            45,
            2
        ]
    },
    {
        number: 8,
        pos: [
            44,
            25
        ]
    },
    {
        number: 9,
        pos: [
            45,
            45
        ]
    },
    {
        number: 10,
        pos: [
            41.5,
            52.5
        ]
    },
    {
        number: 11,
        pos: [
            34,
            70
        ]
    },
    {
        number: 12,
        pos: [
            45,
            93
        ]
    }
];


let $d93a13b3bf4135f6$var$circle, $d93a13b3bf4135f6$var$radius, $d93a13b3bf4135f6$var$circumference;
function $d93a13b3bf4135f6$export$2cd8252107eb640b(id) {
    $d93a13b3bf4135f6$var$circle = document.querySelector(`#${id}>circle`);
    $d93a13b3bf4135f6$var$radius = $d93a13b3bf4135f6$var$circle.r.baseVal.value;
    $d93a13b3bf4135f6$var$circumference = $d93a13b3bf4135f6$var$radius * 2 * Math.PI;
    $d93a13b3bf4135f6$var$circle.style.strokeDasharray = `${$d93a13b3bf4135f6$var$circumference} ${$d93a13b3bf4135f6$var$circumference}`;
    $d93a13b3bf4135f6$var$circle.style.strokeDashoffset = `${$d93a13b3bf4135f6$var$circumference}`;
}
function $d93a13b3bf4135f6$export$e352b740a6841494(fraction) {
    const offset = $d93a13b3bf4135f6$var$circumference - fraction * $d93a13b3bf4135f6$var$circumference;
    $d93a13b3bf4135f6$var$circle.style.strokeDashoffset = offset;
}


function $15bf6a3816abfb50$export$f10f97528f780cc6(element) {
    element.setAttribute('open', '');
}
function $15bf6a3816abfb50$export$9c35fb790e61b3f6(element) {
    if (element.hasAttribute('open')) $15bf6a3816abfb50$export$ff74030248f7f2bd(element);
    else $15bf6a3816abfb50$export$f10f97528f780cc6(element);
}
function $15bf6a3816abfb50$export$ff74030248f7f2bd(element) {
    element.removeAttribute('open');
}


const $02bd03287a08e250$export$e0b46b07fd1bee3a = {
    // Menu slide-in
    'menu-btn-open': {
        type: 'aria-label',
        fr: 'Ouvrir le menu',
        en: 'Open menu',
        de: "Men\xfc \xf6ffnen",
        it: 'Apri menu'
    },
    'menu-btn-close': {
        type: 'aria-label',
        fr: 'Fermer le menu',
        en: 'Close menu',
        de: "Men\xfc schlie\xdfen",
        it: 'Chiudi menu'
    },
    'menu-nav-btn-text-audioguide': {
        type: 'aria-label',
        fr: "Retour \xe0 l'audioguide",
        en: 'Back to the audioguide',
        de: "Zur\xfcck zum Audioguide",
        it: 'Torna all\'audioguida'
    },
    'menu-nav-btn-text-audioguide': {
        fr: "Retour \xe0 l'audioguide",
        en: 'Back to the audioguide',
        de: "Zur\xfcck zum Audioguide",
        it: 'Torna all\'audioguida'
    },
    'menu-nav-btn-about': {
        type: 'aria-label',
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    'menu-nav-btn-text-about': {
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    'menu-nav-btn-credits': {
        type: 'aria-label',
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    },
    'menu-nav-btn-text-credits': {
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    },
    'menu-language-select-title': {
        fr: 'Choix de la langue',
        en: 'Language selection',
        de: 'Sprachauswahl',
        it: 'Selezione della lingua'
    },
    // Audioguide page
    'audioguide-title': {
        fr: 'Audioguide',
        en: 'Audioguide',
        de: 'Audioguide',
        it: 'Audioguida'
    },
    'audioguide-transcription-title': {
        fr: 'Transcription',
        en: 'Transcription',
        de: 'Transkription',
        it: 'Trascrizione'
    },
    'transcription-btn-toggle': {
        type: 'aria-label',
        fr: 'Afficher la transcription',
        en: 'Show transcription',
        de: 'Transkription anzeigen',
        it: 'Mostra trascrizione'
    },
    'audioguide-player-loading-text': {
        // Also used for player title
        fr: 'Chargement...',
        en: 'Loading...',
        de: 'Laden...',
        it: 'Caricamento...'
    },
    'play-controls': {
        type: 'aria-label',
        fr: "Contr\xf4les de lecture",
        en: 'Audio playback controls',
        de: 'Wiedergabesteuerung',
        it: 'Controlli di riproduzione'
    },
    'seekForward': {
        type: 'aria-label',
        fr: 'Avancer de 5 secondes',
        en: 'Seek forward 5 seconds',
        de: "5 Sekunden vorw\xe4rts springen",
        it: 'Avanza di 5 secondi'
    },
    'seekBackward': {
        type: 'aria-label',
        fr: 'Reculer de 5 secondes',
        en: 'Seek backward 5 seconds',
        de: "5 Sekunden zur\xfcckspringen",
        it: 'Riavvolgi di 5 secondi'
    },
    'play-pause': {
        type: 'aria-label',
        fr: 'Lecture/Pause',
        en: 'Play/Pause',
        de: 'Wiedergabe/Pause',
        it: 'Riproduci/Pausa'
    },
    // About page
    'about-title': {
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    // Credits page
    'credits-title': {
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    }
};


let $57ed5cef0f0e73ec$var$lang = 'fr'; // Default language
const $57ed5cef0f0e73ec$var$supportedLanguages = [
    'fr',
    'en',
    'de',
    'it'
];
function $57ed5cef0f0e73ec$export$2cd8252107eb640b() {
    // Detect language
    $57ed5cef0f0e73ec$var$lang = (navigator.language || navigator.userLanguage).slice(0, 2);
    if (!$57ed5cef0f0e73ec$var$supportedLanguages.includes($57ed5cef0f0e73ec$var$lang)) $57ed5cef0f0e73ec$var$lang = 'en';
    $57ed5cef0f0e73ec$var$translateAllLocalizedStrings();
}
function $57ed5cef0f0e73ec$export$dec8f99c0c14e178() {
    return $57ed5cef0f0e73ec$var$lang;
}
function $57ed5cef0f0e73ec$export$a3665b844fbc095d(newLang) {
    if ($57ed5cef0f0e73ec$var$supportedLanguages.includes(newLang)) {
        $57ed5cef0f0e73ec$var$lang = newLang;
        document.documentElement.setAttribute('lang', newLang);
        window.dispatchEvent(new Event('languagechange'));
        $57ed5cef0f0e73ec$var$translateAllLocalizedStrings();
        // Update aria-activedescendant for #language-select
        const languageSelect = document.getElementById('language-select');
        languageSelect.setAttribute('aria-activedescendant', `language-select-link-${newLang}`);
    } else console.error(`Unsupported language: ${newLang}`);
}
function $57ed5cef0f0e73ec$var$translateAllLocalizedStrings() {
    for (const [id, string] of Object.entries((0, $02bd03287a08e250$export$e0b46b07fd1bee3a))){
        const element = document.getElementById(id);
        if (!element) {
            console.error(`Element with id ${id} not found`);
            continue;
        }
        if (string[$57ed5cef0f0e73ec$var$lang] === undefined) {
            console.error(`Missing translation for ${id} in ${$57ed5cef0f0e73ec$var$lang}`);
            continue;
        }
        switch(string.type){
            case 'aria-label':
                element.setAttribute('aria-label', string[$57ed5cef0f0e73ec$var$lang]);
                break;
            case undefined:
                // Default case for strings without a type
                element.textContent = string[$57ed5cef0f0e73ec$var$lang];
                break;
            default:
                console.error(`Unknown type for localized string: ${string.type}`);
        }
    }
}
function $57ed5cef0f0e73ec$export$4e490aaac5c28cc3(id) {
    const string = (0, $02bd03287a08e250$export$e0b46b07fd1bee3a)[id];
    if (string === undefined) {
        console.error(`Missing localized string: ${id}`);
        return id;
    }
    if (string[$57ed5cef0f0e73ec$var$lang] === undefined) {
        console.error(`Missing translation for ${id} in ${$57ed5cef0f0e73ec$var$lang}`);
        return id;
    }
    return string[$57ed5cef0f0e73ec$var$lang];
}




let $ec02d5e098e8e7bc$var$menuElement;
let $ec02d5e098e8e7bc$var$menuCloseButtonElement;
let $ec02d5e098e8e7bc$var$menuLinkElements;
let $ec02d5e098e8e7bc$var$languageSelectLinks;
function $ec02d5e098e8e7bc$export$2cd8252107eb640b() {
    $ec02d5e098e8e7bc$var$menuElement = document.getElementById('menu');
    $ec02d5e098e8e7bc$var$menuCloseButtonElement = document.getElementById('menu-btn-close');
    $ec02d5e098e8e7bc$var$menuLinkElements = document.querySelectorAll('.menu-link');
    $ec02d5e098e8e7bc$var$languageSelectLinks = document.querySelectorAll('.language-select-link');
    // Add event listeners for menu buttons
    const menuButtonElement = document.getElementById('menu-btn-open');
    menuButtonElement.addEventListener('click', ()=>(0, $15bf6a3816abfb50$export$f10f97528f780cc6)($ec02d5e098e8e7bc$var$menuElement));
    $ec02d5e098e8e7bc$var$menuCloseButtonElement.addEventListener('click', ()=>{
        (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)($ec02d5e098e8e7bc$var$menuElement);
    });
    $ec02d5e098e8e7bc$var$menuLinkElements.forEach((element)=>{
        element.addEventListener('click', (event)=>{
            event.preventDefault();
            (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)($ec02d5e098e8e7bc$var$menuElement);
            // Close all pages
            const pages = document.querySelectorAll('.page');
            pages.forEach((page)=>{
                (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(page);
            });
            // Close the transcription panel if open
            const transcriptionPanel = document.getElementById('transcription-panel');
            (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(transcriptionPanel);
            // Open the target element
            const target = element.getAttribute('data-page');
            (0, $15bf6a3816abfb50$export$f10f97528f780cc6)(document.getElementById(target));
            // Update the aria-expanded attributes on links
            $ec02d5e098e8e7bc$var$menuLinkElements.forEach((link)=>{
                link.setAttribute('aria-expanded', 'false');
            });
            element.setAttribute('aria-expanded', 'true');
        });
    });
    // Add event listeners for language selection
    $ec02d5e098e8e7bc$var$languageSelectLinks.forEach((element)=>{
        element.addEventListener('click', (event)=>{
            event.preventDefault();
            const newLang = element.getAttribute('lang');
            if (newLang !== (0, $57ed5cef0f0e73ec$export$dec8f99c0c14e178)()) (0, $57ed5cef0f0e73ec$export$a3665b844fbc095d)(newLang);
            (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)($ec02d5e098e8e7bc$var$menuElement);
        });
    });
    // Set the active language link based on the current language
    window.addEventListener('languagechange', ()=>{
        const newLang = (0, $57ed5cef0f0e73ec$export$dec8f99c0c14e178)();
        // Update the current language link
        $ec02d5e098e8e7bc$var$languageSelectLinks.forEach((element)=>{
            const lang = element.getAttribute('lang');
            if (lang === newLang) {
                element.classList.add('current');
                element.setAttribute('aria-selected', 'true');
            } else {
                element.classList.remove('current');
                element.removeAttribute('aria-selected');
            }
        });
    });
}


let $089c40fcbb903d20$var$player;
let $089c40fcbb903d20$var$audioElement;
let $089c40fcbb903d20$var$playControls, $089c40fcbb903d20$var$loading;
let $089c40fcbb903d20$var$seekBackwardBtn, $089c40fcbb903d20$var$seekForwardBtn, $089c40fcbb903d20$var$playPauseBtn, $089c40fcbb903d20$var$playIcon, $089c40fcbb903d20$var$pauseIcon;
let $089c40fcbb903d20$var$playing = false;
let $089c40fcbb903d20$var$currentPoint = null;
function $089c40fcbb903d20$var$init() {
    $57ed5cef0f0e73ec$export$2cd8252107eb640b();
    $ec02d5e098e8e7bc$export$2cd8252107eb640b();
    // Get elements
    $089c40fcbb903d20$var$player = document.getElementById('player');
    $089c40fcbb903d20$var$playControls = document.getElementById('play-controls');
    $089c40fcbb903d20$var$loading = document.getElementById('audioguide-player-loading-text');
    $089c40fcbb903d20$var$seekBackwardBtn = document.getElementById('seekBackward');
    $089c40fcbb903d20$var$seekForwardBtn = document.getElementById('seekForward');
    $089c40fcbb903d20$var$playPauseBtn = document.getElementById('play-pause');
    $089c40fcbb903d20$var$playIcon = document.getElementById('play-icon');
    $089c40fcbb903d20$var$pauseIcon = document.getElementById('pause-icon');
    $089c40fcbb903d20$var$audioElement = document.querySelector('audio');
    // Add event listeners for transcription button
    const transcriptionButtonElement = document.getElementById('transcription-btn-toggle');
    const transcriptionPanel = document.getElementById('transcription-panel');
    transcriptionButtonElement.addEventListener('click', (event)=>{
        event.preventDefault();
        (0, $15bf6a3816abfb50$export$9c35fb790e61b3f6)(transcriptionPanel);
    });
    // Add event listeners for player buttons
    $089c40fcbb903d20$var$seekBackwardBtn.addEventListener('click', ()=>{
        $089c40fcbb903d20$var$audioElement.currentTime -= 5;
        $089c40fcbb903d20$var$updateProgress();
    });
    $089c40fcbb903d20$var$seekForwardBtn.addEventListener('click', ()=>{
        $089c40fcbb903d20$var$audioElement.currentTime += 5;
        $089c40fcbb903d20$var$updateProgress();
    });
    $089c40fcbb903d20$var$playPauseBtn.addEventListener('click', ()=>{
        if ($089c40fcbb903d20$var$playing) $089c40fcbb903d20$var$audioElement.pause();
        else $089c40fcbb903d20$var$audioElement.play();
    });
    // Periodically update the progress indicator
    setInterval(()=>{
        if ($089c40fcbb903d20$var$playing) $089c40fcbb903d20$var$updateProgress();
    }, 1000);
    // Handle play event
    $089c40fcbb903d20$var$audioElement.addEventListener('play', (event)=>{
        $089c40fcbb903d20$var$playing = true;
        $089c40fcbb903d20$var$playIcon.classList.add('hidden');
        $089c40fcbb903d20$var$pauseIcon.classList.remove('hidden');
        $089c40fcbb903d20$var$updateProgress();
    });
    // Handle pause event
    $089c40fcbb903d20$var$audioElement.addEventListener('pause', (event)=>{
        $089c40fcbb903d20$var$playing = false;
        $089c40fcbb903d20$var$playIcon.classList.remove('hidden');
        $089c40fcbb903d20$var$pauseIcon.classList.add('hidden');
        $089c40fcbb903d20$var$updateProgress();
    });
    // Reset play/pause buttons when audio ends
    $089c40fcbb903d20$var$audioElement.addEventListener('ended', ()=>{
        $089c40fcbb903d20$var$playing = false;
        $089c40fcbb903d20$var$audioElement.currentTime = 0;
        $089c40fcbb903d20$var$playIcon.classList.remove('hidden');
        $089c40fcbb903d20$var$pauseIcon.classList.add('hidden');
        $089c40fcbb903d20$var$updateProgress();
    });
    // Reset play/pause buttons when audio ends
    $089c40fcbb903d20$var$audioElement.addEventListener('stalled', ()=>{
        // TODO: Handle audio stalling ?
        console.error('Audio stalled');
    });
    // Handle language change
    window.addEventListener('languagechange', ()=>{
        if ($089c40fcbb903d20$var$currentPoint) $089c40fcbb903d20$var$playPoint($089c40fcbb903d20$var$currentPoint, true);
    });
    // Get the map element and clear it
    const mapElement = document.getElementById('points');
    mapElement.innerHTML = '';
    // Place points on the map
    (0, $e560fa9b55d4e311$export$9f048bf86ee2e9d2).forEach((point)=>{
        const pointElement = document.createElement('button');
        // NOTE: Any Tailwind class modification here should be reflected in the
        // placeholder code in index.html
        pointElement.className = `listening-point absolute flex size-[10vw] group open:z-10`;
        pointElement.style = `left: ${point.pos[0]}%; top: ${point.pos[1]}%`;
        pointElement.innerHTML = `
      <span class="pointer-events-none absolute left-0 top-0 inline-flex h-full w-full rounded-full bg-[rgb(194,166,98)] group-open:motion-safe:animate-ping"></span>
      <span class="relative inline-flex size-[10vw] items-center justify-center rounded-full border-[1vw] border-[rgb(194,166,98)] bg-white text-center text-[5vw] font-semibold shadow shadow-black/30 group-open:scale-125 group-open:border-[rgb(194,166,98)] group-open:bg-black group-open:text-white">${point.number}
    `;
        pointElement.setAttribute('aria-label', `Point d'\xe9coute ${point.number}`);
        pointElement.setAttribute('data-point', point.number);
        mapElement.appendChild(pointElement);
        // Add event listeners for point buttons
        pointElement.addEventListener('click', async (event)=>{
            event.preventDefault();
            $089c40fcbb903d20$var$playPoint(point);
        });
    });
}
function $089c40fcbb903d20$var$playPoint(point, force = false) {
    const pointElement = document.querySelector(`[data-point="${point.number}"]`);
    const titleElement = document.querySelector('#title');
    const transcriptionPanel = document.getElementById('transcription-panel');
    $089c40fcbb903d20$var$currentPoint = point;
    if ($089c40fcbb903d20$var$playing) {
        // Stop the audio if it's playing
        $089c40fcbb903d20$var$audioElement.pause();
        $089c40fcbb903d20$var$audioElement.currentTime = 0;
        $089c40fcbb903d20$var$currentPoint = null;
    }
    // Close the player if it's already open
    if (pointElement.hasAttribute('open') && !force) {
        (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(pointElement);
        $089c40fcbb903d20$var$player.classList.add('hidden');
    } else {
        // Close all other points
        const elements = document.querySelectorAll('.listening-point');
        elements.forEach((el)=>{
            if (el !== pointElement) (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(el);
        });
        // Open the clicked point
        (0, $15bf6a3816abfb50$export$f10f97528f780cc6)(pointElement);
        // Close transcription panel if open
        (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(transcriptionPanel);
        // Show loading animation
        $089c40fcbb903d20$var$playControls.classList.add('hidden');
        $089c40fcbb903d20$var$loading.classList.remove('hidden');
        // Set the title to "Loading..."
        titleElement.innerHTML = $57ed5cef0f0e73ec$export$4e490aaac5c28cc3('audioguide-player-loading-text');
        // Fetch transcription title and text
        const transcriptionText = fetch(`./text/${$57ed5cef0f0e73ec$export$dec8f99c0c14e178()}${point.number.toString().padStart(2, '0')}.txt`).then((response)=>response.text()).then((text)=>{
            // Get elements
            const transcriptionElement = document.querySelector('#transcription-content');
            // Split title and transcription
            const lines = text.split('\n');
            const title = lines[0];
            let transcription = lines.slice(2).join('\n\n').trim();
            // Detect missing transcription
            if (transcription.length === 0) transcription = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
            // Insert title and transcription into player
            titleElement.innerHTML = title;
            transcriptionElement.innerHTML = transcription;
            transcriptionElement.scrollTop = 0;
            // show player
            $089c40fcbb903d20$var$player.classList.remove('hidden');
        }).catch((error)=>{
            console.error('Error:', error);
            alert("Le chargement du point d'\xe9coute a \xe9chou\xe9. Veuillez r\xe9essayer.");
            (0, $15bf6a3816abfb50$export$ff74030248f7f2bd)(pointElement);
        });
        // Replace the audio source
        $089c40fcbb903d20$var$audioElement.src = `./audio/${$57ed5cef0f0e73ec$export$dec8f99c0c14e178()}${point.number.toString().padStart(2, '0')}.mp3`;
        $089c40fcbb903d20$var$audioElement.addEventListener('canplay', (event)=>{
            $089c40fcbb903d20$var$playControls.classList.remove('hidden');
            $089c40fcbb903d20$var$loading.classList.add('hidden');
        // Audio should autoplay from <audio autoplay="true">
        // The play controls are shown to the user otherwise
        });
    }
}
function $089c40fcbb903d20$var$updateProgress() {
    const progress = $089c40fcbb903d20$var$audioElement.currentTime / $089c40fcbb903d20$var$audioElement.duration;
    $d93a13b3bf4135f6$export$e352b740a6841494(progress);
    const progressText = document.getElementById('time');
    const timeLeft = $089c40fcbb903d20$var$audioElement.duration - $089c40fcbb903d20$var$audioElement.currentTime;
    const minutes = Math.floor(timeLeft / 60);
    const seconds = Math.floor(timeLeft % 60);
    progressText.innerHTML = `${minutes.toString()}:${seconds.toString().padStart(2, '0')}`;
}
$089c40fcbb903d20$var$init();
$d93a13b3bf4135f6$export$2cd8252107eb640b('progress-indicator');

})();
//# sourceMappingURL=audioguide-cathedrale-lausanne.49fd6d3a.js.map
